/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import "./TopHeader.scss";
import { BsArrowsFullscreen } from "react-icons/bs";
import { AiOutlineFullscreenExit } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { selectPartnerPreferences, selectRetrofitCurrentStep } from "../../../Retrofit/store/slices/retrofit";
import { selectConfigurationType, selectFullScreen, setFullScreen } from "../../store/slices/common";
import { isStartStep } from "../../store/utils/utils";
import { selectCartesianCurrentStep } from "../../../Cartesian/store/slices/cartesian";
import { selectMc12CurrentStep } from "../../../Mc12/store/slices/mc12";
import { selectIntegratedDrivesCurrentStep } from "../../../IntegratedDrives/store/slices/integrated_drives";

/**
 * Sub header of the app.
 */
const TopHeader = ({ ...props }) => {
  const dispatch = useDispatch();
  const fullScreen = useSelector(selectFullScreen);
  const handleSetFullScreen = () => {
    dispatch(setFullScreen(!fullScreen));
  };
  const configurationType = useSelector(selectConfigurationType);
  const retrofitCurrentStep = useSelector(selectRetrofitCurrentStep);
  const cartesianCurrentStep = useSelector(selectCartesianCurrentStep);
  const mc12CurrentStep = useSelector(selectMc12CurrentStep);
  const integratedDrivesCurrentStep = useSelector(selectIntegratedDrivesCurrentStep);
  const partnerPreferences = useSelector(selectPartnerPreferences);

  let currentStep = retrofitCurrentStep;
  if (configurationType === "CARTESIAN") {
    currentStep = cartesianCurrentStep;
  } else if (configurationType === "MC12") {
    currentStep = mc12CurrentStep;
  } else if (configurationType === "INTEGRATED_DRIVES") {
    currentStep = integratedDrivesCurrentStep;
  }
  return (
    !isStartStep(currentStep) &&
    partnerPreferences === null && (
      <div className="TopHeader print:hidden" {...props}>
        {fullScreen ? (
          <div className="z-fullScreen relative w-full sub-header select-none flex border-b-2 border-solid bg-primary border-y-hoverPrimary py-2 px-4 md:px-8">
            <div className="flex-1">
              <img
                src="https://www.se.com/ww/en/assets/564/media/202250/SE_logo-LIO-white_header.svg"
                alt="logo"
                className="h-6"
              />
            </div>

            <div className="flex-1 hidden md:flex md:visible justify-end items-center space-x-3 text-white text-xs">
              {/* <span className=" cursor-pointer">
                {t("msizer.ui.login-register")}
              </span> */}
              <div onClick={() => handleSetFullScreen()}>
                <AiOutlineFullscreenExit className="cursor-pointer text-base" />
              </div>
            </div>
          </div>
        ) : (
          <div className="sub-header select-none flex py-1 px-2 absolute w-fit right-0">
            <div className="flex-1" />

            <div className="flex-1 flex justify-end items-center space-x-3 text-xs text-gray-600">
              <div onClick={() => handleSetFullScreen()}>
                <BsArrowsFullscreen className="cursor-pointer" />
              </div>
            </div>
          </div>
        )}
      </div>
    )
  );
};

export default TopHeader;
